import {
  Component,
  Input
} from '@angular/core';

import {
  HaynesProVesaAdvancedGenericPartModel,
  HaynesProVesaRepairTaskModel,
  HaynesProVesaRepairTimesByGenartModel
} from '../typings/haynes-pro.vesa-advanced';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-vesa-component-related-parts',
  styles: [ require('./haynes-pro.diagnostic-tool.vesa-component-related-parts.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.vesa-component-related-parts.component.html')
})
export class HaynesProDiagnosticToolVesaComponentRelatedPartsComponent {

  @Input() componentImageUrl    : string;
  @Input() genericParts         : Array<HaynesProVesaAdvancedGenericPartModel>          = [];
  @Input() isLoadingRepairTimes                                                         = false;
  @Input() repairTimesByGenart  : Record<string, HaynesProVesaRepairTimesByGenartModel> = {};

  expandedGenartId : string = null;
  imageLoadFailed           = false;

  get imageUrl () : string {
    return this.componentImageUrl || '';
  }

  getJobCount ( part : HaynesProVesaAdvancedGenericPartModel ) : number {
    return this.repairTimesByGenart?.[part?.id]?.job_count || 0;
  }

  getRepairTasks ( part : HaynesProVesaAdvancedGenericPartModel ) : Array<HaynesProVesaRepairTaskModel> {
    return this.repairTimesByGenart?.[part?.id]?.repair_tasks || [];
  }

  hasRepairJobs ( part : HaynesProVesaAdvancedGenericPartModel ) : boolean {
    return this.getJobCount(part) > 0;
  }

  isExpanded ( part : HaynesProVesaAdvancedGenericPartModel ) : boolean {
    return this.expandedGenartId === part?.id;
  }

  onImageError () : void {
    this.imageLoadFailed = true;
  }

  togglePart ( part : HaynesProVesaAdvancedGenericPartModel ) : void {
    if (!this.hasRepairJobs(part)) {
      return;
    }

    this.expandedGenartId = this.expandedGenartId === part?.id
      ? null
      : part?.id;
  }

  trackByPart ( _index : number, part : HaynesProVesaAdvancedGenericPartModel ) : string {
    return part?.id;
  }

  trackByTask ( _index : number, task : HaynesProVesaRepairTaskModel ) : string {
    return task?.id;
  }
}
